<template>
  <div class="col-lg-9">
    <h2>{{ $t('common.hubs') }}</h2>
    <div class="row">
      <Hub :key="hub.key" v-for="hub in displayedHubs" v-bind.sync="hub"></Hub>
    </div>
    <div class="row mt-4">
      <div class="col d-flex justify-content-center mb-3">
        <nav v-show="this.pages.length > 1" aria-label="Page navigation">
          <ul class="pagination">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <a
                type="button"
                class="page-link"
                @click="page--"
                href="#"
                aria-label="Previous"
              >
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li
              v-for="pageNumber in pages"
              class="page-item d-none d-lg-block"
              :class="{ active: page === pageNumber }"
              v-bind:key="pageNumber.index"
            >
              <a
                type="button"
                class="page-link"
                @click="page = pageNumber"
                href="#"
                >{{ pageNumber }}</a
              >
            </li>
            <li class="page-item" :class="{ disabled: page === pages.length }">
              <a
                type="button"
                @click="page++"
                class="page-link"
                href="#"
                aria-label="Next"
              >
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import Hub from '@/components/Hub.vue';

export default {
  name: 'Hubs',
  components: {
    Hub,
  },
  props: {
    hubs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      page: 1,
      perPage: 6,
      pages: [],
    };
  },
  methods: {
    setPages() {
      // Reset pager.
      this.page = 1;
      this.pages = [];
      let numberOfPages = Math.ceil(this.hubs.length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(hubs) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return hubs.slice(from, to);
    },
  },
  computed: {
    displayedHubs() {
      return this.paginate(this.hubs);
    },
  },
  watch: {
    hubs() {
      this.setPages();
    },
  },
};
</script>
